import SalarieAbattement from '@/generated/controls/salarie/SalarieAbattement.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: SalarieAbattement
})
